<div class="park-table">
    <finder-section
        id="{{location.urlFriendlyId}}-park-table"
        [labels]="{ sectionTitle: location.title }"
        [headerIcon]="icon"
        [disableDeepLink]="true"
        [expanded]="true">
        <finder-park-row
            [location]="location"
            [labels]="labels">
        </finder-park-row>
    </finder-section>
    <div class="loading-layer" *ngIf="loading">
        <finder-loading-spinner></finder-loading-spinner>
    </div>
</div>
